/* eslint-disable jsx-a11y/no-static-element-interactions */
import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';

import './index.scss';
import { List, Button, Modal, Label, bindMethods } from '../common';
import Form from './Form';

const formatDuration = (duration) => {
  return moment.utc(moment.duration(duration).asMilliseconds()).format('HH:mm');
};

const isSetupComplete = (softwares) => {
  return !!(softwares && softwares.info && softwares.info.STUDIO_ID);
};

export default class Services extends React.Component {
  constructor() {
    super();
    this.state = {
      form: false,
      modal: '',
      modalData: {},
    };
    bindMethods(this, ['show', 'close', 'openModal', 'closeModal']);
  }

  componentDidMount() {
    this.props.getServices();
    this.props.getCategories();
  }

  show(form) {
    this.setState({
      form,
    });
  }

  close() {
    this.setState({
      form: false,
    });
  }

  openModal(modal, modalData) {
    this.setState({
      modal,
      modalData,
    });
  }

  closeModal() {
    this.setState({
      modal: '',
    });
  }

  render() {
    const { show, close, state, openModal, closeModal } = this;
    const { form, modal, modalData } = state;
    const { saveService, removeService, softwares } = this.props;
    let services = [];
    let staffMembers = [];
    let serviceCategories = [];

    if (
      this.props.services &&
      this.props.services.list &&
      this.props.services.list.length
    ) {
      services = this.props.services.list;
    }
    if (
      this.props.services &&
      this.props.services.categories &&
      this.props.services.categories.length
    ) {
      serviceCategories = this.props.services.categories;
    }
    if (
      this.props.services &&
      this.props.services.staffMembers &&
      this.props.services.staffMembers.length
    ) {
      staffMembers = this.props.services.staffMembers;
    }

    return (
      <div className="staff">
        <div className="card" style={{ overflow: 'unset' }}>
          <div className="card__header">
            <span className="card__header__text">Services</span>
            {isSetupComplete(softwares) ? (
              <Button
                className="btn--link"
                onClick={() => {
                  show({});
                }}
              >
                + Add New Service
              </Button>
            ) : null}
          </div>
          <div className="card__content">
            <div className="voicemails__list">
              <List
                headers={[
                  { label: 'Name' },
                  { label: 'Category' },
                  { label: 'Staff' },
                  { label: 'Duration' },
                  { label: '' },
                ]}
                rows={services}
                loading={this.props.services.loading}
              >
                {(row) => {
                  return (
                    <tr
                      key={row.id}
                      style={{ cursor: 'pointer' }}
                      onClick={() => {
                        show(row);
                      }}
                    >
                      <td>{row.name}</td>
                      <td>{row.category}</td>
                      <td>
                        {(row.staff || []).map((staff) => {
                          return (
                            <div
                              key={`${row.id}${staff.id}`}
                            >{`${staff.first_name} ${staff.last_name}`}</div>
                          );
                        })}
                      </td>
                      <td>{formatDuration(row.duration)}</td>
                      <td>
                        <i
                          className="material-icons"
                          style={{
                            cursor: 'pointer',
                          }}
                          onClick={(e) => {
                            e.stopPropagation();
                            openModal('del', row);
                          }}
                        >delete</i>
                      </td>
                    </tr>
                  );
                }}
              </List>
            </div>
          </div>
          <Form
            key={(form && form.id) || Math.random()}
            show={!!form}
            values={form}
            onClose={close}
            onSave={saveService}
            staffMembers={staffMembers}
            serviceCategories={serviceCategories}
          />
          <Modal
            open={modal === 'del'}
            title="Delete Service"
            onClose={() => {
              closeModal();
            }}
          >
            <Label style={{ display: 'block' }} type="form">
              Are you sure you want to delete the service:
            </Label>
            <Label
              style={{ display: 'block' }}
              type="form"
            >{`${modalData.name}`}</Label>
            <div
              style={{
                textAlign: 'right',
                marginTop: 30,
              }}
            >
              <Button
                type="primary"
                style={{
                  marginRight: 20,
                }}
                onClick={() => {
                  removeService(modalData.id);
                  closeModal();
                }}
              >
                Delete
              </Button>
              <Button
                type="simple"
                onClick={() => {
                  closeModal();
                }}
              >
                Close
              </Button>
            </div>
          </Modal>
        </div>
      </div>
    );
  }
}

Services.defaultProps = {
  getServices: () => {},
  getCategories: () => {},
  saveService: () => {},
  removeService: () => {},
};

Services.propTypes = {
  getServices: PropTypes.func,
  getCategories: PropTypes.func,
  saveService: PropTypes.func,
  removeService: PropTypes.func,
  services: PropTypes.shape({
    list: PropTypes.array.isRequired,
    categories: PropTypes.array.isRequired,
    staffMembers: PropTypes.array,
    loading: PropTypes.bool,
  }).isRequired,
  softwares: PropTypes.shape({
    info: PropTypes.shape({
      STUIDIO_NAME: PropTypes.string,
    }),
  }).isRequired,
};
